export default {
  common: {
    // Header / global nav
    nav: {
      home: "Home",
      find_offer_help: "Find / Offer Help",
      celebrate: "Celebrate a Life",
      family_tree: "Family Tree",
      events: "Events",
      civic_reports: "Civic Reports",
      neighborhood_pulse: "Neighborhood Pulse",
      weather: "Weather",
      nature: "Nature",
      marketplace: "Marketplace",
      news: "News",
      causes: "Causes",
      more: "More",
    },
    // Header buttons
    header: {
      sign_in: "Sign in",
      join: "Join Social Pulse",
      language: "Language",
      search: "Search",
    },
    // Top brand tagline
    tagline: "Connecting Communities · Empowering Lives · Building Social Capital",
    // Locality bar / country picker
    locality: {
      viewing_from: "You're viewing from",
      help_improve: "Help us enhance and improve your location",
      filter_by_country: "Filter by country",
      change: "Change",
      set_your_location: "Set your location",
      set_your_location_hint: "— tap to personalize",
    },
    // Buttons used across the app
    actions: {
      submit_cause: "Submit a Cause / Plea",
      make_donation: "Support Social Pulse Global Initiatives — Make a Donation",
      browse_all: "Browse all sections",
      read_more: "Read more",
      learn_more: "Learn more",
      submit: "Submit",
      cancel: "Cancel",
      save: "Save",
    },
    // News page
    news: {
      title: "Your Daily Briefing.",
      submit_news: "Submit News",
      archive: "Archive",
      weather_nature: "Weather & Nature",
      play_briefing: "Play daily briefing",
      play_briefing_hint: "Listen to the top {{count}} stories · ~{{minutes}} min · in your language",
      read_original: "Read Original",
      view_brief: "View brief",
      also_reported_by: "Also reported by:",
      translate: "Translate",
      listen: "Listen",
      stop: "Stop",
    },
    // FoodPulse-specific vertical (published on foodpulse.net)
    foodpulse: {
      brand: "Food Pulse",
      tagline: "Connecting People · Smarter Food · Stronger Communities",
      hero: {
        eyebrow: "FOOD PULSE — PORTLAND & BEYOND",
        title_a: "Less waste.",
        title_b: "Better meals.",
        title_c: "Real deals.",
        subtitle: "Every day, thousands of pounds of perfectly good produce, bread, and prepared food get thrown out. We connect it to shoppers who want it — at 50–70% off supermarket prices.",
        cta_deals: "Today's deals near you →",
        cta_vendors: "Explore vendors",
        cta_spot: "Spot a deal · earn points →",
      },
      search: {
        placeholder: "Search products, brands or scan a barcode…",
        say_hint: "Say \"organic bananas\"",
        scan_hint: "Scan a barcode",
        photo_hint: "Photo → AI identify",
      },
      stats: {
        volunteers: "Volunteers joined",
        opportunities: "Opportunities matched",
        charity: "Charity reach-outs",
        scanned: "Products scanned",
      },
      nav: {
        home: "Home",
        about: "About",
        discover: "Discover",
        food: "Food",
        recipes: "Recipes",
        health: "Health",
        deals: "Deals",
        community: "Community",
        farming: "Farming",
        food_waste: "Food Waste",
        places: "Places",
        articles: "Articles",
        news: "News",
        marketplace: "Marketplace",
        contact: "Contact",
      },
      lists: {
        wish: "Wish List",
        shopping: "Shopping List",
        pantry: "Pantry/Stock List",
        donation: "Donation List",
        share_deal: "Share a Deal",
        share_surplus: "Share Surplus",
        share_donation: "Share Donation",
        my_lists: "My Lists",
        share_with_community: "Share with the community",
        add_to_your_lists: "Add this to your lists",
      },
      deals: {
        heading: "Save real money on real food",
        eyebrow: "Your local deals today",
        no_deals_nearby: "No active deals for this item nearby yet.",
        spot_one_nearby: "Spot one nearby?",
      },
      product: {
        product_label: "Product",
        foodpulse_id: "FoodPulse ID",
        short_url: "Short URL",
        copy: "copy",
        copied: "copied",
        scan_or_share: "Scan or share",
        where_to_buy: "Where to buy",
        right_now: "right now",
        add_to_wishlist: "Add to Wishlist",
      },
      urban_harvest: {
        title: "Urban Harvest",
        share_backyard_bounty: "Share your backyard bounty",
        suggest_a_tree: "Suggest a tree in your neighborhood",
        your_name: "Your name",
        email: "Email",
        phone_optional: "Phone (optional)",
        city: "City",
        state: "State",
        notes: "Notes",
        notes_placeholder: "Anything else we should know? (accessibility, best time to visit, tree health…)",
        fruit_type: "Fruit / crop type",
        tree_count: "How many trees / plants?",
        submit_suggestion: "Submit suggestion",
      },
      spot_deal: {
        title: "Spot a Deal",
        subtitle: "Spotted a great price? Snap it, share it, earn points.",
        store_name: "Store name",
        product_name: "Product name",
        price: "Price",
        notes: "Notes",
        submit: "Post the deal",
      },
    },
  },
};
